import React, { useEffect, useState } from "react";
import { HardDrive, Trash2 } from "lucide-react";
import { getStorageUsage, clearDownloads } from "@/lib/pwa";

// Parent settings: how much space downloaded stories take, whether the browser
// is keeping them, and a button to clear them.
function size(bytes) {
  if (bytes >= 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function OfflineStorageCard() {
  const [info, setInfo] = useState(null);
  const [clearing, setClearing] = useState(false);
  const [cleared, setCleared] = useState(false);

  const load = async () => setInfo(await getStorageUsage());

  useEffect(() => { load(); }, []);

  const onClear = async () => {
    setClearing(true);
    await clearDownloads();
    setCleared(true);
    setClearing(false);
    load();
  };

  return (
    <section className="hv-card p-6" data-testid="offline-storage-card">
      <div className="flex items-start gap-4">
        <div className="rounded-2xl bg-hv-tealTint text-hv-teal p-3 shrink-0">
          <HardDrive className="w-5 h-5" strokeWidth={2.4} />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="font-bold text-hv-navy text-lg">Offline stories on this device</h2>
          {info ? (
            <p className="text-sm text-hv-slate mt-1" data-testid="offline-storage-usage">
              Using {size(info.usage)}{info.quota ? ` of about ${size(info.quota)}` : ""}.{" "}
              {info.persisted
                ? "The browser is keeping these downloads safe."
                : "The browser may clear these downloads if the device runs low on space."}
            </p>
          ) : (
            <p className="text-sm text-hv-slate mt-1">Checking storage…</p>
          )}
          <div className="mt-4 flex items-center gap-3 flex-wrap">
            <button
              onClick={onClear}
              disabled={clearing}
              className="hv-btn-secondary inline-flex items-center gap-2 px-4 py-2.5 text-sm min-h-[44px] disabled:opacity-70"
              data-testid="offline-clear-downloads"
            >
              <Trash2 className="w-4 h-4" strokeWidth={2.4} /> {clearing ? "Clearing…" : "Clear downloads"}
            </button>
            {cleared && <span className="text-sm font-bold text-hv-teal">Downloads cleared.</span>}
          </div>
        </div>
      </div>
    </section>
  );
}
